import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearLoginStatus, setLoginStatus } from '../helper/utils';

function SignOut() {
  const navigate = useNavigate();

  useEffect(() => {
    // Ask for confirmation before proceeding
    const userConfirmed = window.confirm("Please ensure Session is terminated on telegram before clicking ok");

    if (userConfirmed) {
      // Make a post request to sign out and delete cookies
      axios.post(
        `${process.env.REACT_APP_SERVER_URL}/signout/`, {}, { withCredentials: true }
        // `http://127.0.0.1:8000/webpage/signout/`, {}, { withCredentials: true }

      ).then(() => {
        setLoginStatus(false);
      }).catch(() => {
        setLoginStatus(false);
      });

      // Clear cookies, localStorage, and any other site data
      clearLoginStatus();

      // Navigate to the landing page with a state indicating the user just signed out
      navigate('/', { state: { fromSignOut: true } });
    } else {
      // If the user cancels, you can handle it here, e.g., navigate back or do nothing
      navigate('/previous-page'); // Example: navigate back to a previous page
    }
  }, [navigate]);

  return null; // No need to render anything
}

export default SignOut;
